import React from 'react';
import { Outlet } from 'react-router-dom';

import { useTheme } from '@material-ui/styles';
import { Box } from '@material-ui/core';

import LanguageSwitcher from 'ui-component/LanguageSwitcher';

// ===========================|| MINIMAL LAYOUT ||=========================== //

const MinimalLayout = () => {
    const theme = useTheme();

    return (
        <div>
            <Box sx={{ position: 'absolute', zIndex: 1, top: theme.spacing(1), right: theme.spacing(2) }}>
                <LanguageSwitcher theme="dark" />
            </Box>

            <Outlet />
        </div>
    );
};

export default MinimalLayout;
